export function StoryDetails({ eventType, onFormDataChange }) {
  function handleChange(field, value) {
    onFormDataChange({
      story_details: {
        [field]: value
      }
    })
  }

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold text-gray-800">Story & Details</h2>
  
      <div className="bg-white rounded-lg p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-6">Share Your Story</h3>
        
        <div className="space-y-6">
          {PROMPTS.map((prompt) => {
            const fieldKey = prompt
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '_')
              .replace(/^_+|_+$/g, '') // Convert prompt to snake_case for API
            
            return (
              <div key={prompt} className="space-y-2">
                <label className="text-gray-600">{prompt}</label>
                <textarea
                  className="w-full h-24 p-3 rounded-md bg-gray-50 border border-gray-200"
                  onChange={(e) => handleChange(fieldKey, e.target.value)}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const PROMPTS = [
  'What was happening in the world when you were born?',
  'Are there any special stories about your birth?',
  'What did your parents name you and why?'
] 